function updateHeaderBg() {
  const $activeFrame = $(".frame__action.active").first();
  if ($activeFrame.length) {
    const bgPc = $activeFrame.data("bgPc") || $activeFrame.data("bg");
    const bgMb = $activeFrame.data("bgMb") || bgPc;

    if (bgPc) {
      $("#headerBg").attr("src", bgPc);
    }

    if (bgMb) {
      $("#headerBgMB").attr("src", bgMb);
    }
  }
}

function updateDetailTitleByCard($card) {
  const dayTitle = $.trim(
    $card.find(".condition__card--head span").first().text(),
  );
  if (!dayTitle) {
    return;
  }

  $(".group__detail .battle-register__title")
    .first()
    .text(`Chi tiết nhiệm vụ - ${dayTitle.toLowerCase()}`);
}

function updateProgressBar() {
  const $pointSpans = $(".group__congpham--point span");

  if ($pointSpans.length >= 2) {
    const currentValue = parseFloat($pointSpans.eq(0).text());
    const maxValue = parseFloat($pointSpans.eq(1).text());

    if (maxValue > 0) {
      const percentage = (currentValue / maxValue) * 100;
      const percentageRounded = Math.round(percentage);

      $(".group__congpham--bar .current").css("width", percentage + "%");
      $(".group__congpham--bar .current .value").text(percentageRounded + "%");
    }
  }
}

function updateProgressBarsByDataValue() {
  $("[data-value]").each(function () {
    const rawValue = String($(this).attr("data-value") || "").trim();
    if (!rawValue || rawValue.indexOf("/") === -1) {
      return;
    }

    const parts = rawValue.split("/");
    if (parts.length < 2) {
      return;
    }

    const currentValue = Number(parts[0].replace(/[^\d]/g, ""));
    const maxValue = Number(parts[1].replace(/[^\d]/g, ""));

    if (
      !Number.isFinite(currentValue) ||
      !Number.isFinite(maxValue) ||
      maxValue <= 0
    ) {
      return;
    }

    const percentage = Math.max(
      0,
      Math.min(100, (currentValue / maxValue) * 100),
    );
    const percentageRounded = Math.round(percentage);
    const $bar = $(this);

    $bar
      .find(".current")
      .first()
      .css("width", percentage + "%");
    $bar
      .find(".value")
      .first()
      .text(percentageRounded + "%");
  });
}

function isMobile() {
  return window.innerWidth <= 768;
}

function initConditionCarousel($list) {
  if (!isMobile()) {
    return;
  }

  const $cards = $list.find(".condition__card");
  const total = $cards.length;
  if (total <= 1) {
    return;
  }

  const $group = $list.closest(".group__condition");
  const $btnPrev = $group.find(".condition__btn--prev");
  const $btnNext = $group.find(".condition__btn--next");

  if (!$btnPrev.length || !$btnNext.length) {
    return;
  }

  const listEl = $list.get(0);
  const cardPositions = $cards
    .map(function () {
      return this.offsetLeft;
    })
    .get();

  if (!cardPositions.length) {
    return;
  }

  const maxIndex = total - 1;
  let currentIndex = 0;
  let isAnimating = false;
  let settleTimer = null;
  let scrollRaf = null;

  function clampIndex(index) {
    return Math.max(0, Math.min(maxIndex, index));
  }

  function getNearestIndex(scrollLeft) {
    let nearestIndex = 0;
    let nearestDiff = Infinity;

    for (let i = 0; i < cardPositions.length; i++) {
      const diff = Math.abs(cardPositions[i] - scrollLeft);
      if (diff < nearestDiff) {
        nearestDiff = diff;
        nearestIndex = i;
      }
    }

    return clampIndex(nearestIndex);
  }

  function scrollToIndex(index) {
    currentIndex = clampIndex(index);
    isAnimating = true;
    listEl.scrollTo({
      left: cardPositions[currentIndex],
      behavior: "smooth",
    });

    if (settleTimer) {
      clearTimeout(settleTimer);
    }
    settleTimer = setTimeout(function () {
      isAnimating = false;
      updateState();
    }, 260);
  }

  function updateState() {
    $btnPrev.toggleClass("disabled", currentIndex === 0);
    $btnNext.toggleClass("disabled", currentIndex === maxIndex);
  }

  $btnPrev.off("click.carousel").on("click.carousel", function (e) {
    e.preventDefault();
    if (isAnimating) {
      return;
    }
    scrollToIndex(currentIndex - 1);
    updateState();
  });

  $btnNext.off("click.carousel").on("click.carousel", function (e) {
    e.preventDefault();
    if (isAnimating) {
      return;
    }
    scrollToIndex(currentIndex + 1);
    updateState();
  });

  $list.off("scroll.carousel").on("scroll.carousel", function () {
    if (scrollRaf) {
      return;
    }

    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = null;
      currentIndex = getNearestIndex(listEl.scrollLeft);
      updateState();
    });
  });

  currentIndex = getNearestIndex(listEl.scrollLeft);

  updateState();
}

function initAllConditionCarousels() {
  if (!isMobile()) {
    return;
  }
  $(".group__condition--list").each(function () {
    initConditionCarousel($(this));
  });
}

function bindConditionCardEvents() {
  $(document).on(
    "click",
    ".group__condition--list .condition__card",
    function (e) {
      e.preventDefault();

      const $card = $(this);
      if ($card.hasClass("lock")) {
        return;
      }

      const $list = $card.closest(".group__condition--list");
      $list.find(".condition__card").removeClass("active");
      $card.addClass("active");

      updateDetailTitleByCard($card);
    },
  );
}

$(function () {
  updateHeaderBg();
  bindConditionCardEvents();
  updateProgressBar();
  updateProgressBarsByDataValue();
  initAllConditionCarousels();

  const $activeCard = $(
    ".group__condition--list .condition__card.active",
  ).first();
  if ($activeCard.length) {
    updateDetailTitleByCard($activeCard);
  }

  const frameObserver = new MutationObserver(function () {
    updateHeaderBg();
  });

  $(".frame__action").each(function () {
    frameObserver.observe(this, {
      attributes: true,
      attributeFilter: ["class"],
    });
  });
});
